"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { cloneElement, Children, Component, createRef } from "react";
import classNames from "classnames";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import { withTabs } from "./Tabs";
export var TabListAlign = /* @__PURE__ */function (TabListAlign2) {
  TabListAlign2["Start"] = "start";
  TabListAlign2["Center"] = "center";
  TabListAlign2["End"] = "end";
  return TabListAlign2;
}(TabListAlign || {});
var TabList = /*#__PURE__*/function (_Component) {
  _inherits(TabList, _Component);
  var _super = _createSuper(TabList);
  function TabList() {
    var _this;
    _classCallCheck(this, TabList);
    _this = _super.apply(this, arguments);
    _this.tabListRef = createRef();
    _this.getIndicatorRect = function () {
      var _a, _b;
      var _this$props$tabs = _this.props.tabs,
        selectedIndex = _this$props$tabs.selectedIndex,
        tabRefs = _this$props$tabs.tabRefs;
      var tabListRect = (_a = _this.tabListRef.current) == null ? void 0 : _a.getBoundingClientRect();
      var selected = selectedIndex != null ? tabRefs[selectedIndex] : void 0;
      var selectedTabRect = (_b = selected == null ? void 0 : selected.current) == null ? void 0 : _b.getBoundingClientRect();
      var selectedTabRectLeft = selectedTabRect ? selectedTabRect.left : 0;
      var tabListScrollLeft = _this.tabListRef.current ? _this.tabListRef.current.scrollLeft : 0;
      var tabListRectLeft = tabListRect ? tabListRect.left : 0;
      var left = selectedTabRectLeft + tabListScrollLeft - tabListRectLeft;
      var width = (selectedTabRect == null ? void 0 : selectedTabRect.width) || 0;
      return {
        left: left,
        width: width
      };
    };
    _this.updateIndicator = function () {
      var indicatorRect = _this.getIndicatorRect();
      _this.props.tabs.setIndicator(indicatorRect);
    };
    _this.handleKeyDown = function (event) {
      var _a, _b, _c, _d;
      var _this$props$tabs2 = _this.props.tabs,
        selectedIndex = _this$props$tabs2.selectedIndex,
        setSelectedIndex = _this$props$tabs2.setSelectedIndex,
        tabRefs = _this$props$tabs2.tabRefs,
        focusPanel = _this$props$tabs2.focusPanel;
      var numTabs = tabRefs.length;
      switch (event.key) {
        case "ArrowRight":
          var nextIndex = selectedIndex != null ? (selectedIndex + 1) % numTabs : 0;
          (_a = tabRefs[nextIndex].current) == null ? void 0 : _a.focus();
          setSelectedIndex(nextIndex);
          break;
        case "ArrowLeft":
          var prevIndex = selectedIndex != null ? (selectedIndex - 1 + numTabs) % numTabs : 0;
          (_b = tabRefs[prevIndex].current) == null ? void 0 : _b.focus();
          setSelectedIndex(prevIndex);
          break;
        case "End":
          var lastIndex = numTabs - 1;
          (_c = tabRefs[lastIndex].current) == null ? void 0 : _c.focus();
          setSelectedIndex(lastIndex);
          break;
        case "Home":
          (_d = tabRefs[0].current) == null ? void 0 : _d.focus();
          setSelectedIndex(0);
          break;
        case "ArrowDown":
          event.preventDefault();
          focusPanel();
          break;
      }
    };
    return _this;
  }
  _createClass(TabList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateIndicator();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var numTabsChanged = this.props.tabs.tabRefs.length !== prevProps.tabs.tabRefs.length;
      var indexChanged = this.props.tabs.selectedIndex !== prevProps.tabs.selectedIndex;
      if (numTabsChanged || indexChanged) {
        this.updateIndicator();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isBordered = _this$props.isBordered,
        align = _this$props.align,
        className = _this$props.className,
        children = _this$props.children,
        tabs = _this$props.tabs,
        ariaLabel = _this$props["aria-label"];
      var indicator = tabs.indicator;
      var currentIndicator = (indicator == null ? void 0 : indicator.width) ? indicator : this.getIndicatorRect();
      return /* @__PURE__ */React.createElement("div", {
        className: classNames("tabs__tab-list", className, {
          "tabs__tab-list--bordered": isBordered
        })
      }, /* @__PURE__ */React.createElement("div", {
        className: "tabs__tab-list-inner",
        ref: this.tabListRef,
        onKeyDown: this.handleKeyDown
      }, /* @__PURE__ */React.createElement(ReactResizeDetector, {
        handleWidth: true,
        onResize: this.updateIndicator
      }), !!(currentIndicator == null ? void 0 : currentIndicator.width) && /* @__PURE__ */React.createElement("div", {
        className: "tabs__indicator",
        style: {
          transform: "translate3d(".concat(currentIndicator == null ? void 0 : currentIndicator.left, "px, 0, 0)"),
          width: currentIndicator == null ? void 0 : currentIndicator.width
        }
      }), /* @__PURE__ */React.createElement("div", {
        className: "tabs__tab-list-items tabs__tab-list-items--align-".concat(align),
        role: "tablist",
        "aria-orientation": "horizontal",
        "aria-label": ariaLabel
      }, /* @__PURE__ */React.createElement("div", null, /* @__PURE__ */React.createElement(ReactResizeDetector, {
        handleWidth: true,
        onResize: this.updateIndicator
      }), Children.toArray(children).filter(Boolean).map(function (child, index) {
        return cloneElement(child, {
          index: index
        });
      })))));
    }
  }]);
  return TabList;
}(Component);
TabList.defaultProps = {
  align: "start" /* Start */
};

export default withTabs(TabList);